import { render } from "./TokensIcon.vue?vue&type=template&id=bdda1b18"
const script = {}
script.render = render

export default script